import { render } from "./translators.vue?vue&type=template&id=0285b934&scoped=true"
import script from "./translators.js?vue&type=script&lang=js&external"
export * from "./translators.js?vue&type=script&lang=js&external"

import "./translators.css?vue&type=style&index=0&id=0285b934&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0285b934"]])

export default __exports__